<template>
    <div class="enterDwWrap">
        <div class="bannerBox">
            <img src="../../assets/images/banner_ruzhuyuncang.jpg" alt="" class="bannerImg">
        </div>
        <div class="formWrap">
            <el-form :model="form" ref="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm" >
                <el-form-item label="注册类型" prop="type">
                    <el-radio-group v-model="form.type">
                        <el-radio label="1">公司</el-radio>
                        <el-radio label="2">个人</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="身份类型" prop="idetifyType">
                    <el-radio-group v-model="form.idetifyType">
                        <el-radio label="1">供应商</el-radio>
                        <el-radio label="2">销售商</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="注册手机" prop="phone">
                    <el-input v-model="form.phone" placeholder="请输入注册手机(必填项)" disabled></el-input>
                </el-form-item>
                <el-form-item label="公司名称" prop="companyName" v-if="form.type==1">
                    <el-input v-model="form.companyName" placeholder="请输入公司名称(必填项)"></el-input>
                </el-form-item>
                <el-form-item label="个人姓名" prop="personalName" v-if="form.type==2">
                    <el-input v-model="form.personalName" placeholder="请输入个人姓名(必填项)"></el-input>
                </el-form-item>
                
                <el-form-item label="联系人姓名" prop="contactName">
                    <el-input v-model="form.contactName" placeholder="请输入联系人姓名"></el-input>
                </el-form-item>
                <el-form-item label="联系人手机" prop="contactPhone">
                    <el-input v-model="form.contactPhone" placeholder="请输入联系人手机"></el-input>
                </el-form-item>
                <el-form-item label="公司地址" prop="validBrandAddress">
                    <area-picker type="add" :data.sync="addressObj" size="large" @change="getCompanyAreaData" />
                </el-form-item>
                <el-form-item label="详细地址" prop="detailAddress">
                    <el-input v-model="form.detailAddress" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">申请入驻</el-button>
                    <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
                    <el-button @click="back">返回</el-button>
                </el-form-item>
            </el-form>

        </div>

    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    import api from '@/api/index.js'
    import request from '@/utils/request'
    import areaPicker from '@/components/areaPicker.vue'
    export default {
        components: {
            areaPicker
        },
        computed: {
            ...mapGetters([
                'userId', 'userType', 'phone'
            ])
        },
        data() {
            var validBrandAddress = (rule, value, callback) => {
                let result = this.addressObj.regionProvince && this.addressObj.regionProvince.region_id && (!this.addressObj
                    .regionCity || !this.addressObj.regionCity.region_id)
                if (result) {
                    callback(new Error('请选择市/区'))
                } else {
                    callback()
                }
            };
            return {
                isLoading: false,
                // status: '', // p - 审核中  y - 审核通过  n - 审核未通过
                form: {
                    type: '1', // 1 - 公司  2 - 个人
                    idetifyType:'1',
                    companyName: '',
                    personalName: '',
                    contactName: '',
                    contactPhone: '',
                    detailAddress: '',
                    phone: '',
                },
                rules: {
                    type: [{
                        required: true,
                        message: '请选择用户类型',
                        trigger: 'blur'
                    }, ],
                    companyName: [{
                        required: true,
                        message: '请输入公司名称',
                        trigger: 'blur'
                    }],
                    personalName: [{
                        required: true,
                        message: '请输入用户名称',
                        trigger: 'blur'
                    }],
                    phone: [{
                        required: true,
                        message: '请输入注册手机号',
                        trigger: 'blur'
                    }],
                    idetifyType: [{
                        required: true,
                        message: '请选择身份类型',
                        trigger: 'blur'
                    }],
                    
                    // contactName: [{
                    //     required: true,
                    //     message: '请输入联系人姓名',
                    //     trigger: 'blur'
                    // }],
                    // contactPhone: [{
                    //     required: true,
                    //     message: '请输入联系人电话',
                    //     trigger: 'blur'
                    // }],
                    validBrandAddress: [{
                        validator: validBrandAddress
                    }],
                },
                addressObj: {
                    regionProvince: {
                        region_name: '',
                        region_id: ''
                    },
                    regionCity: {
                        region_name: '',
                        region_id: ''
                    },
                    regionDistrict: {
                        region_name: '',
                        region_id: ''
                    }
                },
            }
        },
        created() {
            this.form.phone = this.phone
        },
        methods: {
            back(){
              this.$router.back()
            },
            getCompanyAreaData(data) {
                this.$refs['ruleForm'].validateField('validBrandAddress')
            },
            inputBrandDetailAddress() {
                this.$refs['ruleForm'].validateField('validBrandAddress')
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let deviceInfo = window.navigator.userAgent
                        let arg = {
                            "phone": this.form.phone,
                            "userInitialType": this.form.idetifyType,//初始类型（用户首次选择），1为供应商，2为销售商'
                            "userIndividualName": this.form.type == 2 ? this.form.personalName : "",
                            "userOrganizationName": this.form.type == 1 ? this.form.companyName : "",
                            "userDeviceInfo": JSON.stringify(deviceInfo),
                            "companyKeyPerson": this.form.contactName,
                            "companyKeyPersonPhone": this.form.contactPhone,
                            "userId": this.userId,
                            "userProvince": this.addressObj.regionProvince.region_id,
                            "userCity": this.addressObj.regionCity.region_id,
                            "userDistrict": this.addressObj.regionDistrict.region_id,
                            "userAddress": this.form.detailAddress,
                        }
                        console.log(this.form)
                        console.log(arg)
                        request({
                            url: api.applyForDw,
                            loading: true,
                            data: arg
                        }).then(res => {
                            console.log(res)
                            if (res.errorCode == 200) {
                               this.$alert('请耐心等待平台人员审核，并保持电话畅通。', '您的申请已提交', {
                                 confirmButtonText: '确定',
                                 callback: action => {
                                   this.$message({
                                     type: 'info',
                                     message: `action: ${ action }`
                                   });
                                 }
                               });
                                
                            } else {
                                this.$message.error(res.errorMsg)
                            }
                        }).catch(err => {
                            console.log(err)
                        })
                        
                        

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });


            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            getBrandInfo() {
                request({
                    url: api.showUserAuthBrand,
                    data: {
                        userId: this.userId
                    }
                }).then(res => {
                    // console.log('api.showUserAuthBrand', res)
                    if (res.errorCode === 200) {
                        if (res.data.companyBrand) {
                            this.brandTags = res.data.companyBrand.split(',')
                        }
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .enterDwWrap {
        width: 1184px;
        margin: 0 auto;
    }

    .bannerBox{
        margin-top:24px;
        display: flex;
        .bannerImg {
            width: 100%;
        }
    }
    .formWrap{background: #fff;padding:20px 50px;}
</style>
